module.exports = __webpack_public_path__ + "static/img/65_T-shirt.c517b64a.jpg";